export function stripPrefix(path) {
  const basePath = process.env.BASE_PATH
  if (!basePath) return path
  if (!path.startsWith(basePath)) return path
  return path.substring(basePath.length)
}
